<template>
  <div
    :class="
      'customer-view-menu-view wg-row ' +
        (typeof license !== 'undefined' ? license.licenseHash : '')
    "
  >
    <div
      v-if="loading"
      class="wg-row"
      style="align-items: center; justify-content: center; margin-top: 20px"
    >
      <vue-simple-spinner
        size="medium"
        :line-fg-color="appColor"
      ></vue-simple-spinner>
    </div>
    <template v-else>
      <!-- INFO MODAL -->
      <wg-modal
        v-if="showInfoModal"
        @closeModal="showInfoModal = false"
        :width="windowWidth >= 992 ? '600px' : '90%'"
      >
        <div slot="body" class="wg-row">
          <div class="vertical-height-div" style="height:10px;"></div>
          <div
            class="wg-row"
            style="justify-content:center;align-items:center;"
          >
            <div
              style="
                min-width: 35px;
                width: 35px;
                height: 35px;
                margin-right: 10px;
              "
            >
              <world-object-icon :type="'work'" :obj="work" :isImg="true">
              </world-object-icon>
            </div>
            <div style="font-size: 24px">
              {{ license.name || work.name }}
            </div>
          </div>
          <div class="vertical-height-div" style="height:20px;"></div>
          <div class="wg-row">
            <div
              class="wg-row"
              style="align-items:center;flex-wrap:nowrap;padding-bottom:5px;border-bottom:1px solid #ccc;"
            >
              <img
                class="com-anm22-app-img-fixed-height-m"
                :src="$anm22.icons.getWorldIcon('time')"
              />
              <div
                class="com-anm22-app-text-xl"
                style="font-weight:bold;margin-left:5px;"
              >
                {{ $anm22.strLang(lang, "Hours", "Orari") }}
              </div>
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <div class="wg-row" style="flex-direction:column;padding:0 5px;">
              <div
                v-for="(day, i) in license.openingHours"
                :key="'oh-' + i"
                class="wg-row"
                :style="{
                  fontWeight: now.isoWeekday - 1 == i ? 'bold' : '',
                  marginBottom: '5px',
                }"
              >
                <div class="wg-col wg-xs-12 wg-sm-4 com-anm22-app-text-l">
                  {{
                    $anm22.capitalizeFirst($moment(i + 1, "E").format("dddd"))
                  }}
                </div>
                <div class="wg-col wg-xs-12 wg-sm-8 com-anm22-app-text-l">
                  <div class="wg-row">
                    <div
                      v-for="(oh, j) in day"
                      :key="'oh-' + i + '-' + j"
                      class="display-flex"
                      style="margin-right:5px;"
                    >
                      {{
                        $moment
                          .tz(oh["from"], "HH:mm", timezone)
                          .format("HH:mm") +
                          " - " +
                          $moment
                            .tz(oh["to"], "HH:mm", timezone)
                            .format("HH:mm")
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <template v-if="address">
            <div class="vertical-height-div" style="height:15px;"></div>
            <div
              class="wg-row modal-info-address-label"
              style="align-items:center;flex-wrap:nowrap;padding-bottom:5px;border-bottom:1px solid #ccc;"
            >
              <img
                class="com-anm22-app-img-fixed-height-m"
                :src="$anm22.icons.getWorldIcon('placeBlack')"
              />
              <div
                class="com-anm22-app-text-xl"
                style="font-weight:bold;margin-left:5px;"
              >
                {{ $anm22.strLang(lang, "Address", "Indirizzo") }}
              </div>
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <div class="wg-row modal-info-address-data">
              <div class="com-anm22-app-text-xl" style="margin-left: 5px">
                {{ address }}
              </div>
            </div>
            <!-- <template v-if="place.latitude && place.longitude">
              <div class="vertical-height-div" style="height:10px;"></div>
              <div class="wg-row" style="height:200px;">
                <GmapMap
                  v-if="!isOffline"
                  ref="mapRef"
                  :center="{ lat: place.latitude, lng: place.longitude }"
                  :zoom="5"
                  map-type-id="roadmap"
                  style="width:100%;height:100%;"
                >
                  <GmapMarker
                    :position="{ lat: place.latitude, lng: place.longitude }"
                    :icon="{
                      size: new google.maps.Size(32, 32),
                      scaledSize: new google.maps.Size(32, 32),
                      url: $anm22.icons.getFoodIcon('markerFood')
                    }"
                    :zIndex="1"
                  />
                </GmapMap>
                <img
                    v-else
                    class="com-anm22-app-img-l"
                    style="margin:auto;"
                    :src="$anm22.icons.getWorldIcon('offline')"
                >
              </div>
            </template> -->
            <div class="vertical-height-div" style="height:20px;"></div>
          </template>
          <div class="vertical-height-div" style="height:15px;"></div>
          <div
            v-if="work.phoneAreaCode && work.phoneNumber"
            class="wg-row modal-info-phone-box"
          >
            <div
              class="wg-row modal-info-phone-label"
              style="align-items:center;flex-wrap:nowrap;padding-bottom:5px;border-bottom:1px solid #ccc;"
            >
              <img
                class="com-anm22-app-img-fixed-height-m"
                :src="$anm22.icons.getWorldIcon('phone')"
              />
              <div
                class="com-anm22-app-text-xl"
                style="font-weight:bold;margin-left:5px;"
              >
                {{ $anm22.strLang(lang, "Phone", "Telefono") }}
              </div>
            </div>
            <div class="vertical-height-div" style="height:10px;"></div>
            <a
              class="modal-info-phone-link"
              style="margin-left:5px;"
              :href="'tel:' + work.phoneAreaCode + work.phoneNumber"
            >
              <div class="com-anm22-app-text-l">
                {{ work.phoneAreaCode + " " + work.phoneNumber }}
              </div>
            </a>
          </div>
          <div class="vertical-height-div" style="height:15px;"></div>
        </div>
      </wg-modal>
      <!-- INFO + MENU -->
      <div
        id="main-scrolling-div"
        class="wg-row com-anm22-app-scrolling-panel menu"
        :style="{ height: windowHeight - 60 + 'px' }"
      >
        <!-- INFO = COVER + INFO_CARD (sticky) -->
        <!-- <info :license="license" :scrollY="mainScroll"></info> -->
        <div class="wg-row cover" :style="coverStyle"></div>
        <div
          class="wg-row info card"
          :style="{ height: infoCardHeight + 'px' }"
        >
          <div class="wg-row" style="flex-direction: column">
            <div class="wg-row" style="align-items: center">
              <div
                :class="'license-logo-container ' + license.licenseHash"
                style="min-width:30px;width:30px;height:30px;margin-right:5px;"
              >
                <world-object-icon :type="'work'" :obj="work" :isImg="true">
                </world-object-icon>
              </div>
              <div class="com-anm22-app-text-xl">
                {{ license.name || work.name }}
              </div>
              <img
                class="com-anm22-app-img-fixed-height-m"
                :src="$anm22.icons.getWorldIcon('info')"
                style="margin-left:5px;cursor:pointer;opacity:0.4;"
                @click="showInfoModal = true"
              />
            </div>
            <div v-if="error" class="wg-row error">
              <div
                v-if="error === 1"
                class="com-anm22-app-text-m"
                style="text-align: center"
              >
                {{
                  $anm22.strLang(
                    lang,
                    "! We are sorry but the selected store isn't taking order at the moment",
                    "! Ci dispiace ma il locale non accetta ordini al momento"
                  )
                }}
              </div>
              <div
                v-else-if="error === 2"
                class="com-anm22-app-text-m"
                style="text-align: center"
              >
                {{
                  $anm22.strLang(
                    lang,
                    "! This restaurant only accepts Spiagge.it as valid payment method. Unfortunately, no Spiagge.it active registration has been found for this user.",
                    "! Questo locale accetta solo Spiagge.it come metodo di pagamento valido. Sfortunatamente, non è stata trovata alcuna registrazione valida su Spiagge.it per questo utente."
                  )
                }}
              </div>
            </div>
            <!-- Opening hours -->
            <div class="wg-row hours">
              <img
                class="com-anm22-app-img-fixed-height-s"
                :src="$anm22.icons.getWorldIcon('time')"
              />
              <div class="com-anm22-app-text-l" style="margin:0 5px;">
                {{ todayOhString }}
              </div>
              <div
                v-if="license.seasonalClosure"
                class="com-anm22-app-text-l"
                style="color:#EF5350;"
              >
                {{
                  $anm22.strLang(
                    lang,
                    "Seasonal closure",
                    "Chiusura stagionale"
                  )
                }}
              </div>
              <div
                v-else-if="open"
                class="com-anm22-app-text-l"
                style="color:#64dd17;"
              >
                {{ $anm22.strLang(lang, "Open now", "Aperto ora") }}
              </div>
              <div v-else class="com-anm22-app-text-l" style="color:#EF5350;">
                {{ $anm22.strLang(lang, "Closed now", "Chiuso ora") }}
              </div>
            </div>
          </div>
        </div>
        <!-- MENU = CATEGORIES (sticky) + PRODUCTS -->
        <products :topOffset="infoCardHeight"></products>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Spinner from "vue-simple-spinner";
import Products from "../../components/customer/Products.vue";

export default {
  components: {
    "vue-simple-spinner": Spinner,
    Products,
  },
  data() {
    return {
      loading: true,
      mainScroll: 0,
      showInfoModal: false,
      pageStyle: "standard",
      pageCustomCSS: null,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      licenseSelected: (state) => state.licenseSelected,
      windowWidth: (state) => state.windowWidth,
      windowHeight: (state) => state.windowHeight,
      isOffline: (state) => state.offline.isOffline,
      appColor: (state) => state.config.appColor,
    }),
    lang() {
      if (this.user) {
        return this.$store.state.lang;
      } else {
        return (navigator.language || navigator.userLanguage).substring(0, 2);
      }
    },
    infoCardHeight() {
      if (this.error) {
        return 100;
      } else {
        return 70;
      }
    },
    productsHeight() {
      return this.windowHeight - 80 - (this.windowWidth < 992 ? 49 : 0);
    },
    license() {
      return this.$store.getters["foodLicenses/getByHash"](
        this.licenseSelected
      );
    },
    work() {
      return this.$store.getters["works/get"](this.license.work);
    },
    timezone() {
      return this.work.timezone;
    },
    place() {
      const places = this.$store.getters["workPlaceAssocs/getByWork"](
        this.work.idWorldWork
      ).map((wpa) => this.$store.getters["places/get"](wpa.place));
      if (places.length > 0) {
        return places[0];
      } else {
        return null;
      }
    },
    address() {
      if (this.place) {
        return this.$anm22.getAddressFromPlace(this, this.place);
      } else {
        return "";
      }
    },
    // Styles
    coverStyle() {
      return {
        backgroundImage: "url(" + this.license.coverImg + ")",
      };
    },
    now() {
      return this.$moment().tz(this.timezone);
    },
    open() {
      if (this.license.seasonalClosure) {
        return false;
      }
      const day = this.license.openingHours[this.now.format("e")];
      for (let i = 0; i < day.length; i++) {
        const ohs = day[i];
        const from = this.$moment.tz(ohs["from"], "HH:mm", this.timezone);
        const to = this.$moment.tz(ohs["to"], "HH:mm", this.timezone);
        if (to.isBefore(from, "hour minute")) {
          to.add(1, "days");
        }
        if (this.now.isBetween(from, to, "hour minute", "[]")) {
          return true;
        }
      }
      return false;
    },
    todayOhString() {
      let string = "";
      const today = this.license.openingHours[this.now.isoWeekday() - 1];
      for (let i = 0; i < today.length; i++) {
        const oh = today[i];
        string +=
          this.$moment.tz(oh["from"], "HH:mm", this.timezone).format("HH:mm") +
          " - " +
          this.$moment.tz(oh["to"], "HH:mm", this.timezone).format("HH:mm") +
          " ";
      }
      return string;
    },
    error() {
      // Restaurant accepts orders
      if (this.license.interrupted) {
        return 1;
      }
      // YB payment
      if (
        this.license.paymentMethods.filter(
          (p) => p.customer && (p.id !== 7 || this.ybRegs.active)
        ).length === 0
      ) {
        return 2;
      }
      return null;
    },
    products() {
      return this.$store.getters["foodProducts/getByLicense"](
        this.license.id
      ).filter((p) => !p.deleted && p.visibleByCustomer);
    },
  },
  methods: {
    mainScrolled(e) {
      this.mainScroll = e.target.scrollTop;
    },
    async loadPage() {
      const response = await this.$http.get("place-order/menu");
      await Promise.all([
        this.$store.dispatch("foodLicenses/update", {
          vlf: this.$vlf("foodLicenses"),
          objs: [response.data.license],
        }),
        this.$store.dispatch("foodCategories/update", {
          vlf: this.$vlf("foodCategories"),
          objs: response.data.categories,
        }),
        this.$store.dispatch("foodProducts/update", {
          vlf: this.$vlf("foodProducts"),
          objs: response.data.products,
        }),
        this.$store.dispatch("works/update", {
          vlf: this.$vlf("works"),
          objs: response.data.works,
        }),
        this.$store.dispatch("places/update", {
          vlf: this.$vlf("places"),
          objs: response.data.places,
        }),
        this.$store.dispatch("workPlaceAssocs/update", {
          vlf: this.$vlf("workPlaceAssocs"),
          objs: response.data.workPlaceAssocs,
        }),
      ]);

      this.checkPageStyle();

      this.loading = false;
      this.$Progress.finish();
    },
    checkPageStyle() {
      /** Club del Sole */
      const cdsIds = [32, 36, 37, 38, 39, 40, 42, 43, 44, 45, 46, 47, 97, 98, 133, 136, 137, 138, 139, 140, 141, 142, 143, 145, 151, 152, 153, 154, 155];
      if (typeof this.license !== "undefined") {
        if (cdsIds.includes(this.license.id)) {
          this.pageCustomCSS =
            "https://www.clubdelsole.com/upl/lp/yourFood/assets/clubdelsole.css";
          let file = document.createElement("link");
          file.rel = "stylesheet";
          file.href = this.pageCustomCSS;
          document.head.appendChild(file);
        }
      }
    },
  },
  async created() {
    document.title = "Menu";
    this.$store.dispatch("headbar/setHeadbarTitle", "Menu");
    this.checkPageStyle();
    this.loadPage();
  },
  beforeDestroy() {
    if (this.pageCustomCSS) {
      document
        .querySelectorAll("link[href='" + this.pageCustomCSS + "']")
        .forEach(function(e) {
          e.parentElement.removeChild(e);
        });
    }
  },
};
</script>

<style lang="scss" scoped>
.cover {
  height: 200px;
  width: 100%;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.card {
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.03);
  padding: 5px 10px;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.info {
  position: sticky;
  top: -1px;
  z-index: 100;
}
.elements-counter {
  font-size: 20px;
  margin-right: 5px;
}
.menu {
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.error {
  background: #ffd740;
  border-radius: 5px;
  padding: 5px;
}
.hours {
  height: 25px;
  flex-wrap: nowrap;
  align-items: center;
}
@media screen and (max-width: 921px) {
  .card {
    border-bottom: 1px solid #ccc;
  }
}
// Transition hours div
.slide-enter-active {
  transition: all 0.5s ease;
}
.slide-leave-active {
  transition: all 0.5s ease;
}
.slide-enter,
.slide-leave-to {
  opacity: 0;
}
</style>
